// extracted by mini-css-extract-plugin
export default {"ErrorMessageAccordion":"ErrorMessage_ErrorMessageAccordion__8yic2","accordionHeader":"ErrorMessage_accordionHeader__04E0g","errorIcon":"ErrorMessage_errorIcon__UzA3j"};